import { call, put, takeLatest } from "redux-saga/effects";
import { setLoaderAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";
import {
  addDepositInvoiceAction,
  addInvoiceAction,
  bulkInvoiceAction,
  DBOConnectQuickBookAction,
  deleteInvoiceAction,
  downloadInvoiceAction,
  getAllCustomerListAction,
  getAllInvoiceListAction,
  getInvoiceListByCustomerIdAction,
  getInvoiceListResponseByCustomerId,
  getSingleInvoiceAction,
  sendInvoiceEmailAction,
  setAddInvoiceResponse,
  setAllCustomerListAction,
  setAllInvoiceListAction,
  setAllInvoiceListLoading,
  setBulkInvoiceResponse,
  setDBOConnectQuickBookAction,
  setDeletedInvoiceResponse,
  setDepositInvoiceCreated,
  setDownloadInvoiceAction,
  setErrorUploadToQuickBookAction,
  setSendInvoiceEmailResponse,
  setSingleInvoiceAction,
  setSyncBulkFaildedResponse,
  setSyncBulkInvoiceResponse,
  setUploadToQuickBookAction,
  syncBulkInvoiceAction,
  uploadToQuickBookAction,
} from "../reducers/invoiceSlice";
import store from "../store";
import JsFileDownloader from "js-file-downloader";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllInvoiceListSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setAllInvoiceListLoading(true));
  try {
    console.log("payload-38", payload);
    const {
      search,
      page,
      limit,
      orderBy,
      orderIn,
      invoiceNumber,
      customerId,
      onlyOutstanding,
      onlySynced,
      startDate,
      endDate,
      invoiceType,
      customer_email,
      action,
    } = payload?.payload || {};

    // 👇 Build URL conditionally
    let url = `account/invoices?search=${search}&page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}&invoiceNumber=${
      invoiceNumber ?? ""
    }&customerId=${customerId ?? ""}&onlyOutstanding=${
      onlyOutstanding ?? ""
    }&onlySynced=${onlySynced ?? ""}&startDate=${startDate ?? ""}&endDate=${endDate ?? ""}&invoiceType=${
      invoiceType ?? ""
    }&customerEmail=${customer_email ?? ""}`;

    // 👉 If action exists, attach to URL
    if (action) {
      url += `&action=${action}`;
    }

    const res = yield call<any>(callAPI, {}, "get", url);

    if (res?.data) {
      yield put(setAllInvoiceListAction(res?.data));
        if(action === "email"){
        handleSuccess(res);
      }else if(action === "pdf"){
      const fileUrl = res?.data?.pdfUrl;
        let fileUrlData = fileUrl.split("?")[0].split("/");

        new JsFileDownloader({
          url: fileUrl,
          filename: `${fileUrlData[fileUrlData.length - 1]
          }`,
        })
          .then(() => {
            handleSuccess(res);
            store.dispatch(setLoaderAction(false));
          })
          .catch((e) => {});
    }
    yield put(setAllInvoiceListLoading(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAllInvoiceListLoading(false));
  }
  yield put(setLoaderAction(false));
  yield put(setLoaderAction(false));
}

function* addInvoiceSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  console.log("payload", payload);
  const { insurance_amount, deposit_outstanding_balance, ...rest } =
    payload?.payload || {};
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      "account/invoices"
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddInvoiceResponse(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddInvoiceResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getSingleInvoiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    console.log("action in getSingleInvoiceSaga", action);
    const { invoiceNo, leadNo, quoteId, invoiceType, isRestart } = action.payload; // Directly access the payload
    let url = "";
    if (invoiceNo && !isRestart) {
      url = `account/invoices/${invoiceNo}`;
    } else if (isRestart) {
      url = `account/load-invoice?lead_id=${leadNo}&invoice_no=${invoiceNo}&invoice_type=${invoiceType}&is_restart=true${quoteId ? `&quote_id=${quoteId}` : ''}`;
    } else {
      url = `account/load-invoice?lead_id=${leadNo}&invoice_type=${invoiceType}${quoteId ? `&quote_id=${quoteId}` : ''}`;
    }
    const apiResponse = yield call<any>(callAPI, {}, "get", url);
    if (apiResponse?.data) {
      yield put(setSingleInvoiceAction(apiResponse?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* DBOConnect(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { tenant_id } = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `auth/qbo-connect?tenantId=${tenant_id}`
    );
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setDBOConnectQuickBookAction(apiResponse?.data || null));
      store.dispatch(setLoaderAction(false));
    }
  } catch (error: any) {
    // error?.response && handleError(error?.response);
    // yield put(setErrorUploadToQuickBookAction(true));
    error?.code === "ERR_NETWORK" && handleError(error);
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* uploadToQuickBookSaga(action: any): any {
  yield put(setLoaderAction(true));
  console.log("action", action);
  try {
    const { invoice_number } = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `account/send-to-quickbook/${invoice_number}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUploadToQuickBookAction(true));
      store.dispatch(setLoaderAction(false));
      yield put(setLoaderAction(false));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    yield put(setErrorUploadToQuickBookAction(true));
    // called DBOConnectQuickBookAction saga to get the DBO link if network error occurs
    // yield put(DBOConnectQuickBookAction({ tenant_id: "your-tenant-id" }));
    error?.code === "ERR_NETWORK" && handleError(error);
    console.log("Catch Error-", error);
    yield put(setLoaderAction(false));
  }
  yield put(setLoaderAction(false));
}

function* downloadInvoiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { invoice_number, actionType } = action.payload; // Directly access the payload

    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `account/invoices/${invoice_number}?action=${actionType}`
    );

    if (apiResponse?.success === true) {
      if (actionType === "email") {
        apiResponse && handleSuccess(apiResponse);
        store.dispatch(setDownloadInvoiceAction(true));
      } else {
        yield put(setLoaderAction(true));
        const fileUrl = apiResponse?.data?.pdfUrl;
        let fileUrlData = fileUrl.split("?")[0];
        fileUrlData = fileUrlData.split("/");
        new JsFileDownloader({
          url: fileUrl,
          filename: `${fileUrlData[fileUrlData?.length - 1]}`,
        })
          .then(function () {
            apiResponse && handleSuccess(apiResponse);
            store.dispatch(setDownloadInvoiceAction(true));
            store.dispatch(setLoaderAction(false));
            // Called when download ended
          })
          .catch(function (error) {
            // Called when an error occurred
          });
      }
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* sendInvoiceEmailSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { invoice_number } = action.payload; // Directly access the payload

    const apiResponse = yield call<any>(
      callAPI,
      { payload: { invoice_number } },
      "post",
      `account/send-email`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSendInvoiceEmailResponse(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSendInvoiceEmailResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* deleteInvoiceSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    const { invoice_number } = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `account/invoices/${invoice_number}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeletedInvoiceResponse(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeletedInvoiceResponse(false));
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

const addDepositInvoiceSaga = function* (action: any): any {
  yield put(setLoaderAction(true));
  console.log("payload", action);
  const { deposit_amount, ...rest } = action.payload || {};
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: rest },
      "post",
      `account/invoices`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDepositInvoiceCreated(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDepositInvoiceCreated(false));
  }
  yield put(setLoaderAction(false));
};

const getAllCustomerListSaga = function* (action: any): any {
  yield put(setLoaderAction(true));
  console.log("action", action);
  const { search, page, limit, orderBy, orderIn,customerId } = action.payload || {};
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `client/customers?search=${search}&customerId=${customerId}&page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`
    );
    if (res?.data) {
      yield put(setAllCustomerListAction(res?.data?.list || []));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
};

const bulkInvoiceSaga = function* (action: any): any {
  yield put(setLoaderAction(true));
  console.log("payload", action);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: action.payload },
      "post",
      `account/invoices/bulk-action`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setBulkInvoiceResponse(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setBulkInvoiceResponse(false));
  }
  yield put(setLoaderAction(false));
};

const syncBulkInvoiceSaga = function* (action: any): any {
  yield put(setLoaderAction(true));
  console.log("payload", action);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: action.payload },
      "post",
      `account/send-to-quickbook`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSyncBulkInvoiceResponse(true));
      yield put(setSyncBulkFaildedResponse(apiResponse?.data || []));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSyncBulkInvoiceResponse(false));
  }
  yield put(setLoaderAction(false));
}

const getInvoiceListByCustomerIdSaga = function* (action: any): any {
  yield put(setLoaderAction(true));
  console.log("action", action);
  const { customerId } = action.payload || {};
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `account/lead-invoices?lead_id=${customerId}`
    );  
    if (res?.data) {
      yield put(getInvoiceListResponseByCustomerId(res?.data || []));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
};

export function* watchInvoice() {
  yield takeLatest<any>(getAllInvoiceListAction, getAllInvoiceListSaga);
  yield takeLatest<any>(addInvoiceAction, addInvoiceSaga);
  yield takeLatest<any>(getSingleInvoiceAction, getSingleInvoiceSaga);
  yield takeLatest<any>(downloadInvoiceAction, downloadInvoiceSaga);
  yield takeLatest<any>(uploadToQuickBookAction, uploadToQuickBookSaga);
  yield takeLatest<any>(sendInvoiceEmailAction, sendInvoiceEmailSaga);
  yield takeLatest<any>(deleteInvoiceAction, deleteInvoiceSaga);
  yield takeLatest<any>(addDepositInvoiceAction, addDepositInvoiceSaga);
  yield takeLatest<any>(getAllCustomerListAction, getAllCustomerListSaga);
  yield takeLatest<any>(bulkInvoiceAction, bulkInvoiceSaga);
  yield takeLatest<any>(syncBulkInvoiceAction, syncBulkInvoiceSaga);
  yield takeLatest<any>(getInvoiceListByCustomerIdAction, getInvoiceListByCustomerIdSaga);
  yield takeLatest<any>(DBOConnectQuickBookAction, DBOConnect);
}
